import { call, put, all, takeLatest } from 'redux-saga/effects'
import { get } from 'lodash'
import toast from 'react-hot-toast'
import api from '../../../services/axios'
import { cerqRequestOptIn } from '../cerc/actions'
import {
    loginSuccess,
    loginFailure,
    registerSuccess,
    registerFailure,
} from './actions'
import {
    LoginTypes,
    InstitutionLogin,
    InstitutionRegister,
    LoginSave,
    RegisterTypes,
} from './types'

interface ProtocolLogin {
    payload: InstitutionLogin
    type: string
}

interface ProtocolRegister {
    payload: InstitutionRegister
    type: string
}

function* loginRequest({ payload }: ProtocolLogin) {
    try {
        const { data } = yield call(api.post, '/login', payload)
        api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
        yield put(loginSuccess(data))
        toast.success('Logado com sucesso!')
    } catch (error) {
        yield put(loginFailure())
        const erro = get(error, 'response.data.error', '')
        toast.error(erro)
    }
}

function* registerRequest({ payload }: ProtocolRegister): any {
    try {
        yield call(api.post, '/createinst', payload)
        yield put(registerSuccess())
        toast.success('Conta criada com sucesso!')
        const cnpj_cpf = payload.cnpj_cpf
        yield put(cerqRequestOptIn({ cnpj_cpf }))
    } catch (error) {
        const erro = get(error, 'response.data.error', '')
        toast.error(erro)
        yield put(registerFailure())
    }
}

function persistRehydrate({ payload }: any) {
    const token = get(payload, 'auth.token', '')
    if (!token) return
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default all([
    takeLatest(LoginTypes.LOGIN_REQUEST, loginRequest),
    takeLatest(RegisterTypes.REGISTER_REQUEST, registerRequest),
    takeLatest(LoginSave.PERSIST_REHYDRATE, persistRehydrate),
])
